import { IEnvironment } from '@env/environment.interface';
import packageJson from '../../package.json';

export const environment: IEnvironment = {
  name: 'demo',
  production: true,
  API_URL: 'https://api-demo.talent.silae.fr',
  MY_SILAE_LABEL: 'mySilae (demo)',
  MY_SILAE_URL: 'https://demo-preview.t.my.silae.fr',
  POST_HOG_ENABLED: false,
  POST_HOG_API_KEY: 'phc_nseD9iPWJvxrdjSamLUxSHW0bhsfZzUOXyM0xwq5WrW',
  POST_HOG_HOST: 'https://sniffy.my.silae.fr',
  VERSION: packageJson.version,
  WHITELISTED_DOMAIN: 'api-demo.talent.silae.fr',
  VUE: 'https://demo-preview.t.my.silae.fr',
};
